module.exports = __webpack_public_path__ + "img/bg_circle.9cf374a4.gif";